// extracted by mini-css-extract-plugin
export default {"tile":"ToastErrorTile_tile__dx398","icon":"ToastErrorTile_icon__6B7sk","content":"ToastErrorTile_content__cSaYh","text":"ToastErrorTile_text__kc3Lh"};